<template>
    <NoProvider v-if="options == null || options.length <= 0" @changePaymentOption="changePaymentOption" />
    <div v-else ref="pay-card-otp" id="pay-card-otp" class="opt-content-wrapper pay-pane active py-0 pb-0 transfer">

        <div v-if="loading" class="py-5">
            <Spinner class="my-2 animate slideInTop" :color="client_info.colors.app" />
            <p v-html="loadingMessage"></p>
        </div>

        <div v-else>
            <!-- ========================== COMING SOON ====================== -->
            <div class="modal-body pb-1" v-if="current_option == null || isComingSoon">
                <div class="text-center mt-3">
                    <div class="modal-body text-center mb-4">
                        <!--h1 style="color: grey; width: 100%;">{{ data.option }}</-h1-->
                        <img v-if="current_option.image_url" :src="current_option.image_url" class="provider-logo"
                            alt="" style="width: 20%; height :auto" />
                        <h4 style="" class="mt-3 gray">Coming Soon</h4>
                        <p class="mt-3 mb-5" style="font-size:14px;"> <strong>{{ current_option.option }}</strong> is
                            under
                            development, please use other payment method.</p>
                    </div>
                </div>

                <div v-if="!loading && this.data.channels.length > 1" class="col-12 px-0 mt-4 text-center">
                    <a v-if="options.length > 1" href="javascript:void(0)" class="text-tiny go-back"
                        @click.prevent="goBack">Go Back </a> <br><br>
                    <a href="javascript:void(0)" class="change-option" @click.prevent="changePaymentOption"> &larr;
                        Choose
                        another method </a>
                </div>
            </div>
            <!-- ========================== COMING SOON ====================== -->

            <div v-else>

                <!-- Customer Processing Fees -->
                <p class="mt-3 bold" v-if="showProcessingFeeMessage.length" v-html="showProcessingFeeMessage"></p>
                <!-- Customer Processing Fees -->

                <div class="text-center"
                    v-if="(current_option.provider != 'undefined' && !loading) && !isCoralPay && view != 'service_call'">
                    <img v-if="current_option.provider"
                        :src="current_option.image_url ? current_option.image_url : '/img/' + current_option.provider.toLowerCase() + '-logo.svg'"
                        class="provider-logo" alt="" />
                </div>

                <div class="modal-body pb-1">

                    <!-- Multiple Options -->
                    <!-- ========================== OPTION LISTS ====================== -->
                    <div v-if="view == 'options'" class="row mx-0">
                        <p class="text-center heading mt-2 mb-0" style="font-szie:14px;"
                            v-html="headingMessage || 'Select your preferred bank'"></p>
                        <div class="options-list">
                            <ul class="mx-0 px-0  itemList v2-flex-container"
                                :style="data.channels.length > 4 ? '{ flex-wrap: wrap }' : ''">

                                <li class="app-text-color fg-1" @click.prevent="selectOption(key)" :key="key"
                                    :id="'list-' + key" v-for="(item, key) in chunk_items"
                                    :style="{ 'color': `${client_info.colors.app}` }">
                                    <img :src="item.provider ? (item.image_url ? item.image_url : '/img/' + item.provider.toLowerCase() + '-logo.svg') : item.image_url"
                                        alt="" />
                                    <p class="title"> {{ (item.option) }}</p>
                                </li>
                            </ul>
                        </div>

                        <!-- PAGINATOR -->
                        <div v-if="this.data.details.action.length > client_info.paginate_count">
                            <Paginator
                                v-if="client_info.paginate_count > 0 && client_info.paginate_count > options.length ? client_info.paginate_count : (options.length > 5)"
                                :per_page="client_info.paginate_count" :items="options" @next="handleNext"
                                @prev="handlePrev" :page="current_page" />
                        </div>

                    </div>
                    <!-- ========================== OPTION LISTS ====================== -->

                    <!-- ======================== INSTRUCTION =============================-->
                    <div v-if="view == 'instruction'" class="row m-0 text-center">
                        <div class="col-12 px-0">

                            <!-- Cash Type -->
                            <div v-if="type == 'cash'" class="mt-2 text-center gray" v-html="headingMessage"></div>

                            <div v-else class="mt-2 text-center gray" v-html="headingMessage"></div>

                            <!-- Transfer Confirmation button -->
                            <!-- p v-if="type == 'current_option.transfer'" class="mt-3 mb-2 text-center text-tiny">Once your transfer is successful, please click the <strong>Done. Confirm Payment</strong> button below</!-->

                            <div class="form-group text-center mt-4 mb-3">
                                <a v-if="type !== 'cash' && data.details.action.length > 1" href="javascript:void(0)"
                                    class="text-tiny gray change-choice" @click.prevent="changeChoice"> Change
                                    Choice</a>

                                <a v-else-if="type === 'cash'" href="javascript:void(0)" class="text-tiny gray"
                                    @click.prevent="changeChoice">&larr; Change Provider </a>
                            </div>

                            <!--
                        <div v-if="type != 'cash'" class="form-group mb-2">
                            <button type="submit" class="btn app-bg-color" :style="button_color" ref="btnActionPay" @click.prevent="confirmPayment">Done. Confirm Payment</button>
                        </div>  -->
                        </div>
                    </div>
                    <!-- ======================== INSTRUCTION =============================-->

                    <!-- ======================== SERVICE CALL =============================-->
                    <div v-if="view == 'service_call'" class="row m-0 text-center">

                        <div v-if="loading" class="py-5">
                            <Spinner class="my-2 animate slideInTop" :color="client_info.colors.app" />
                            <p>{{ loadingMessage }}</p>
                        </div>

                        <div v-else class="col-12 px-0">

                            <div v-if="isCoralPay">
                                <h4 class="text-center heading mt-2 mb-0">Select your Bank's USSD</h4>
                                <div class="options-list">
                                    <ul class="mx-0 px-0  itemList v2-flex-container"
                                        :style="data.channels.length > 4 ? '{ flex-wrap: wrap }' : ''">
                                        <li class="app-text-color fg-1" @click.prevent="selectUssdBank(key)" :key="key"
                                            :id="'list-' + key" v-for="(item, key) in chunk_banks_items"
                                            :style="{ 'color': `${client_info.colors.app}` }">
                                            <img :src="item.image_url" alt="" />
                                            <p class="title"> {{ item.name }} ({{ item.ussdString }})</p>
                                        </li>
                                    </ul>

                                    <!-- PAGINATOR -->
                                    <div v-if="banks.length > client_info.paginate_count">
                                        <Paginator
                                            v-if="client_info.paginate_count > 0 && client_info.paginate_count > options.length ? client_info.paginate_count : (banks.length > 5)"
                                            :per_page="client_info.paginate_count" :items="banks" @next="handleNext"
                                            @prev="handlePrev" :page="current_page" />
                                    </div>
                                </div>
                            </div>
                            <div v-else>

                                <div v-if="showPwtAccountDetails">
                                    <PWTAccountRhemito v-if="isInternationalPWT"
                                        @continueToMerchant="handleContinueToMerchant"
                                        @changePaymentOption="changePaymentOption" :client_info="client_info"
                                        :account_details="account_details" />

                                    <PWTAccount v-else @continueToMerchant="handleContinueToMerchant"
                                        @changePaymentOption="changePaymentOption" :client_info="client_info"
                                        :account_details="account_details" />
                                </div>


                                <div v-else>
                                    <h3 class="mt-2 text-center gray text-bold h3" v-html="headingMessage"
                                        :class="isEnd ? 'mb-5' : ''"></h3>

                                    <!-- ACCOUNT NO. -->
                                    <p class="text-left" v-html="headingMessage"></p>

                                    <input type="number" data-me class="form-control no-label" v-model="account_no"
                                        maxlength="11" autocomplete="off" minlength="9" autofocus required
                                        @focus="isFocus = true" @blur="isFocus = false"
                                        onKeyPress="if(this.value.length == 11) return false;"
                                        :style="{ borderColor: (isFocus ? client_info.colors.app_color : '#e4e4e4') }" />

                                    <div v-if="!isEnd" class="form-group text-center my-4">
                                        <a v-if="type !== 'cash' && data.details.action.length > 1"
                                            href="javascript:void(0)" class="text-tiny gray change-choice"
                                            @click.prevent="changeChoice"> Change Choice</a>

                                        <a v-else-if="type === 'cash'" href="javascript:void(0)" class="text-tiny gray"
                                            @click.prevent="changeChoice">&larr; Change Provider </a>
                                    </div>

                                    <div class="form-group mt-3 mb-2">
                                        <button :disabled="isCoralDisabled" type="submit" class="btn app-bg-color"
                                            :style="button_color" ref="btnActionPay" @click.prevent="callSendInvoice">
                                            Continue
                                        </button>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                    <!-- ======================== SERVICE CALL =============================-->

                    <!-- ======================== SERVICE CALL OTP =============================-->
                    <div v-if="view == 'service_call_otp'" class="row m-0 text-center">
                        <div class="col-12 px-0">

                            <div class="form-group ">
                                <p class="mt-2 text-center gray text-bold" v-html="headingMessage"
                                    :class="isEnd ? 'mb-5' : ''"></p>
                                <form class="pay-otp-code mb-4" @submit.prevent="">
                                    <input type="number" class="form-control no-label text-center" v-model="otp"
                                        maxlength="10" autocomplete="off" minlength="4" autofocus required
                                        @focus="isFocus = true" @blur="isFocus = false"
                                        onKeyPress="if(this.value.length == 10) return false;"
                                        :style="{ borderColor: (isFocus ? client_info.colors.app_color : '#e4e4e4') }" />
                                    <span class="invalid-feedback" :style="(errors.otp) ? 'display : inline' : ''">{{
                                        errors.otp }}</span>
                                </form>

                                <div id="new-saved" class="switch">
                                    <a v-if="has_ussd" class="left active pointer mb-3" @mouseover="hover = true"
                                        @mouseleave="hover = false" href="javascript:void(0)"
                                        :style="hover ? hover_in_style : ''" @click.prevent="validateUssd"
                                        style="font-size:12px; border: solid 1px #000; color: #000; border-radius:3px; background:#fff;">
                                        I dialed the USSD code </a>
                                </div>

                                <button :disabled="otp.length <= 3" type="button" class="btn app-bg-color"
                                    :style="button_color" @click.prevent="submitOtp">
                                    Continue
                                </button>
                            </div>
                        </div>
                    </div>
                    <!-- ======================== SERVICE CALL OTP =============================-->

                </div>

                <div v-if="!loading && !isEnd" class="col-12 px-0 mt-4 text-center">
                    <a href="javascript:void(0)" class="change-option" @click.prevent="changePaymentOption"
                        title="Change payment method"> &larr; Choose another method </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
/* eslint-disable */
import axios from 'axios';
import Spinner from './includes/Spinner.vue'
import Paginator from './includes/Paginator.vue'
import PWTAccount from './PWTAccount.vue'
import NoProvider from "./NoProvider.vue"
import PWTAccountRhemito from './PWTAccountRhemito.vue';
import {
    coralPayBanks
} from './includes/banks.js';

export default {
    name: 'transfer',
    props: {
        data: Object,
        client_info: Object,
        button_color: Object,
    },

    components: {
        Spinner,
        Paginator,
        PWTAccount,
        PWTAccountRhemito,
        NoProvider,
    },
    computed: {
        isCoralDisabled() {
            return !(this.bank_code !== '' && this.account_no.length === 10)
        }
    },

    created() {
        if (this.data.details.action) {
            this.options = this.data.details.action
            this.headingMessage = this.data.details.message
            this.type = this.data.details.auth_type.toLowerCase()

            if (this.options.length === 0) {
                this.options = null;
                return;
            } else if (this.options.length === 1) {
                this.shouldShow = true;
                this.current_option = this.options[0];
                this.headingMessage = this.current_option.instructions
                this.selectOption(0)
            } else { // more than 1

                // Settle Pagination here
                this.chunk_items = this.options.slice(0, this.client_info.paginate_count > 0 ? this.client_info.paginate_count : 5);
            }
        }

    },

    mounted() {
        this.hover_in_style = {
            background: this.client_info.colors.app,
            "border-color": this.client_info.colors.app,
            color: '#000',
            "border-radius": "3px;",
        };

        this.hover_out_style = {
            "font-size": "12 px;",
            "color": "#000;",
            "border": `solid 1px ${this.client_info.colors.app || '#000'};`,
            "border-radius": "3px;",
        };

    },

    data() {
        return {
            isComingSoon: false,
            isInternationalPWT: false,
            showPwtAccountDetails: false,
            isEnd: false,
            isFocus: true,
            account_details: {},
            view: 'options',
            focusColor: '',
            options: [],
            current_option: {},
            type: '',
            longNameClass: 'width: 65%; margin-right: 5px; font-size :12px',
            loading: false,
            loadingMessage: 'Please wait, loading.....',
            sendingOtp: false,
            sendingPhone: false,
            headingMessage: '',
            otp: '',
            current_page: 0,
            chunk_items: [],
            chunk_banks_items: [],
            isCoralPay: false,
            errors: {
                trx_otp: false,
                otp: '',
            },
            account_no: '',
            bank_code: '',
            hover_in_style: {},
            hover_out_style: {},
            has_ussd: false,
            hover: false,
            currency: 'NGN',
            showProcessingFeeMessage: '',

        }
    },
    methods: {

        changePaymentOption() {

            if (this.view == 'service_call_otp') {
                const newRef = `${this.$store.state.parentTransRef}-${this.$generateTransactionRef()}`;
                this.$store.dispatch('transRef', newRef);
                this.$store.dispatch('isFailed', true);
            }

            this.$store.dispatch('customer_processing_fee', 0.00);
            this.showProcessingFeeMessage = '';

            this.$parent.changeComponent("PaymentOptions");
            this.showProcessingFeeMessage = '';

        },

        goBack() {
            this.isComingSoon = false;
            this.headingMessage = this.data.details.message
            this.current_option = '';
            this.view = 'options'
            this.$store.dispatch('customer_processing_fee', 0.00);
            this.showProcessingFeeMessage = '';

        },

        changeChoice() {
            this.headingMessage = this.data.details.message
            this.current_page = this.current_option.page;
            this.current_option = '';
            this.view = 'options'
            this.$store.dispatch('customer_processing_fee', 0.00);
            this.showProcessingFeeMessage = '';

        },

        handlePrev(val) {
            this.current_page = val.page;
            if (this.isCoralPay)
                this.chunk_banks_items = val.data;
            else
                this.chunk_items = val.data;
        },

        handleNext(val) {
            this.current_page = val.page;
            if (this.isCoralPay)
                this.chunk_banks_items = val.data;
            else
                this.chunk_items = val.data;
        },

        handleProviderService(val) {

            if (!val.instructions) {
                return;
            }

            if (val.instructions.length > 20 && val.instructions != null) { // Show instruction
                let instruction = val.instructions
                instruction = instruction.replace('{{tranaction_ref}}', this.$store.state.transRef).replace('{{customer_ref}}', this.$store.state.payload.transaction.customer.customer_ref);
                instruction = instruction.replace('{{provider}}', this.current_option.provider);
                this.headingMessage = instruction;
                this.view = 'instruction';

            } else { // instruction is a service call in OnePipe
                this.$store.dispatch('service_call_payload', {});
                this.view = 'service_call';

                let vm = this;
                switch (val.instructions.toLowerCase()) {
                    case "open account":
                    case "open_account":
                    case "account_opening":
                    case "account opening":


                        // Check if provider is rhemito and it has the obecjts.
                        if (Object.keys(val).includes('meta') && val.meta != null  && Object.keys(val.meta).includes('account_number')) {
                            this.isEnd = true;
                            this.loading = false;
                            let account_details = val.meta;
                            const initialPayload = this.$parent.getInitialPayload();
                            if (Object.keys(account_details).includes('accountNumber') || Object.keys(account_details).includes('account_number')) {
                                this.handlePWTUpSellAndNotificationDetails(initialPayload, this.current_option.extras, account_details);
                            }
                        } else { // call open account
                            vm.callOpenAccount(val.instructions.toLowerCase());
                        }
                        break;

                    case "send invoice":
                    case "send_invoice":
                        if (this.current_option.provider.toLowerCase() === "coralpay") {
                            this.isCoralPay = true;
                            let sortedBanks = coralPayBanks.sort(this.$sortCompare)
                            this.banks = sortedBanks;
                            this.chunk_banks_items = sortedBanks.slice(0, this.client_info.paginate_count > 0 ? this.client_info.paginate_count : 5);
                        } else {
                            vm.callSendInvoice();
                        }
                        break;
                }
            }
        },

        selectOption(index) {
            const val = this.options[index];
            this.current_option = val;

            if (!val) {
                return;
            }

            if (Object.keys(val).includes('extras') && val.extras != null) {
                if (val.extras.customer_processing_fee_flat && parseFloat(val.extras.customer_processing_fee_flat) > 0) {
                    let fees = parseFloat(val.extras.customer_processing_fee_flat);
                    this.$store.dispatch('customer_processing_fee', fees.toFixed(2));
                    this.showProcessingFeeMessage = ` A surcharge of <strong>₦${fees.toFixed(2)}</strong> has been added to your payment. `
                } else if (val.extras.customer_processing_fee_percentage && parseFloat(val.extras.customer_processing_fee_percentage) > 0) {
                    let percentage_price_as_flat = (parseFloat(this.getInitialPayload().transaction.amount) / 100) * (parseFloat(val.extras.customer_processing_fee_percentage) / 100)
                    this.$store.dispatch('customer_processing_fee', percentage_price_as_flat.toFixed(2));
                    this.showProcessingFeeMessage = ` A surcharge of <strong>₦${percentage_price_as_flat.toFixed(2)}</strong> has been added to your payment. `
                }
            }

            if (val.provider && (val.provider !== null || val.provider !== "")) {
                if (val.provider.toLowerCase() === "comingsoon") { // Show coming soon
                    this.isComingSoon = true;
                } else {
                    // console.log("Provider is present check for instruction");
                    this.handleProviderService(val);
                }
            } else {
                // console.log("Provider is null")
                this.handleProviderService(val);
            }

        },

        confirmPayment() {
            let res = JSON.parse(window.raw);
            res.message = "Transaction processed successfully";

            if (res.data.client_info)
                delete res.data.client_info;

            if (res.data.paymentoptions)
                delete res.data.paymentoptions;
            // console.log(res);

            delete res.data.client_info;

            window.raw = JSON.stringify(res);
            this.$parent.continueToMerchant({
                // status: res.status,
                status: this.data.details.status_type === 'message' ? 'PendingFulfilment' : res.status || res.status,
                message: res.data.message,
            });

            return;
        },

        backToMerchant() {
            let res = JSON.parse(window.raw);
            res.message = "Transaction processed successfully";

            if (res.data.client_info)
                delete res.data.client_info;

            if (res.data.paymentoptions)
                delete res.data.paymentoptions;

            // console.log(res);

            delete res.data.client_info;

            window.raw = JSON.stringify(res);
            return this.$parent.continueToMerchant({
                status: "Successful", // Overwrite the status as 'PendingValidation' since user would have to pay later.
                message: res.data.message,
            });

        },

        selectUssdBank(key) {
            const bank = this.banks[key];
            this.bank_code = bank.cbn_code;
            this.callSendInvoice()
        },

        sendSms(initialPayload, app_name, sms_message, account_details, auth_provider = null) {

            let initialAmount = initialPayload.transaction.amount
            let nariaAmount = (initialAmount / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            let account_name = account_details.account_name || account_details.accountName
            let account_number = account_details.account_number || account_details.accountNumber
            let bank_name = account_details.bank_name || account_details.bankName
            let message_body = sms_message.replace('{Amount}', nariaAmount).replace('{AccountName}', account_name).replace('{AccountNumber}', account_number).replace('{BankName}', bank_name).replace('{AppName}', app_name)
            let data2 = {
                api_key: this.$store.state.api_key,
                endpoint: 'transact',
                payload: {
                    request_ref: this.$generateRequestRef(),
                    request_type: 'send_sms',
                    auth: {
                        type: null,
                        secure: null,
                        auth_provider,
                    },
                    transaction: {
                        transaction_ref: this.$store.state.transRef + '-js-pwt-send-sms',
                        transaction_desc: "Send PWT account details",
                        amount: 0,
                        customer: initialPayload.transaction.customer,
                        meta: {
                            amount: initialAmount,
                            route: 'termii'
                        },
                        details: {
                            message_body,
                            sender_id: 'Benefit',
                            message_title: 'Account Details'
                        }
                    }
                },
            };

            // set mobile_no
            data2.payload.transaction.customer.customer_ref = data2.payload.transaction.customer.mobile_no;
            let dataPayload = this.$generateToken(data2)
            axios.post(this.baseApiUrl + "v2/onepipe/js", {
                data: dataPayload
            }, {
                timeout: this.API_CALL_TIMEOUT, // 3 mins
                headers: {
                    Authorization: `Bearer ${this.$store.state.payload.api_key}`
                }
            })
                .then(({
                    data
                }) => {
                    // console.log(data)
                }).catch(err => {
                    console.log(`[Couldn't send SMS due to]: ${err}`)
                })

        },

        sendEmail(initialPayload, account_details, custom_message = null) {

            try {
                let app_info = this.$store.state.app_info
                let logo_url = Object.keys(app_info).includes('logo_url') && app_info.logo_url != null ? app_info.logo_url : this.client_info.merchant.logo
                let secondary_colour = this.client_info.colors.secondary
                let primary_colour = this.client_info.colors.primary_button
                let account_name = account_details.account_name || account_details.accountName
                let account_number = account_details.account_number || account_details.accountNumber
                let bank_name = account_details.bank_name || account_details.bankName
                let app_name = this.client_info.meta.app_name
                let customer = initialPayload.transaction.customer
                let customer_name = `${customer.firstname} ${customer.surname}`
                let footer_message = ''
                let initialAmount = initialPayload.transaction.amount
                let nariaAmount = (initialAmount / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

                let mail = {
                    sender: {
                        fromName: app_name,
                        fromEmailAddress: "no-reply@onepipe.io"
                    },
                    message: {
                        templateId: "MSG_TABLE",
                        subject: `${app_name} PWT - Account Details`,
                        body: 'Your account details are below',
                        bodyParams: {
                            logoUrl: logo_url,
                            primaryColour: primary_colour,
                            secondaryColour: secondary_colour,
                            footerText: this.client_info.name,
                            footerAddress: "",
                            header: {
                                column_1: "",
                                column_2: ""
                            },
                            rows: [{
                                column_1: 'Bank Name',
                                column_2: bank_name !== undefined ? bank_name : 'NA',
                            },
                            {
                                column_1: 'Account Number',
                                column_2: account_number,
                            },
                            {
                                column_1: 'Account Name',
                                column_2: account_name,
                            }
                            ]
                        },
                        attachments: []
                    },
                    recipient: {
                        recipientName: customer_name || 'User',
                        recipientEmail: null,
                        recipientEmailAddresses: customer.email.split(',')
                    }
                }

                if (custom_message) {
                    custom_message = custom_message.replace('{Amount}', nariaAmount).replace('{AccountName}', account_name).replace('{AccountNumber}', account_number).replace('{BankName}', bank_name).replace('{AppName}', app_name);
                    mail.message.bodyParams.bottomText = custom_message;
                }

                new Promise.resolve(() => {
                    axios.post("https://email.bits.staging.onepipe.io/v1/send", mail, {
                        timeout: this.API_CALL_TIMEOUT, // 3 mins
                        headers: {
                            Authorization: `Bearer SEND_EMAIL_API_KEY`
                        }
                    })
                        .then(({
                            data
                        }) => {
                            // console.log(`[Send Email status]`, data.status);
                            resolve(data);
                        }).catch(error => {
                            console.log(`[Send Email Error]`, error);
                            resolve(error);

                        })

                })
            } catch (error) {
                console.error('SendEmail', error)
            }
        },

        async handlePWTUpSellAndNotificationDetails(initialPayload, extras, account_details) {

            let details = {
                account_name: account_details.account_name || account_details.accountName,
                account_number: account_details.account_number || account_details.accountNumber,
                bank_name: account_details.bank_name || account_details.bankName,
                app_name: this.client_info.meta.app_name,
                amount: (parseInt(initialPayload.transaction.amount) / 100).toFixed(2), // to 2 DP
                currency: initialPayload.transaction.currency ? initialPayload.transaction.currency : (initialPayload.transaction.meta.currency ? initialPayload.transaction.meta.currency : 'NGN'),
                payment_reference: null
            }
            if (Object.keys(account_details).includes('meta') && Object.keys(account_details.meta).includes('sort_code')) {
                details = Object.assign(details, {
                    sort_code: account_details.meta.sort_code,
                });

                this.isInternationalPWT = true;
            }

            if (Object.keys(account_details).includes('meta') && Object.keys(account_details.meta).includes('payment_reference')) {
                details = Object.assign(details, {
                    payment_reference: account_details.meta.payment_reference,
                });
            }

            this.account_details = details;

            if (Object.keys(extras).includes('js_upsell_notice') && extras.js_upsell_notice.length > 5) {
                this.account_details.js_upsell_notice = extras.js_upsell_notice;
            }

            try {
                if (Object.keys(extras).includes('send_notification_alert') && extras.send_notification_alert.length > 2) {
                    let notifications = extras.send_notification_alert.toLowerCase().split(';');
                    if (notifications.length > 0) {
                        let customer = initialPayload.transaction.customer;
                        if (notifications.includes('sms') && customer.mobile_no && Object.keys(extras).includes('sms_account_number_message') && extras.sms_account_number_message.length > 10) {
                            this.sendSms(initialPayload, this.client_info.meta.app_name, extras.sms_account_number_message, account_details);
                        }

                        if (notifications.includes('email') && customer.email && !['', null, undefined].includes(customer.email)) {
                            let email_footer_message = Object.keys(extras).includes('email_footer_message') && extras.email_footer_message.length > 10 ? extras.email_footer_message : null;
                            this.sendEmail(initialPayload, account_details, email_footer_message);
                        }
                    }
                }
            } catch (error) {
                console.error('[handlePWTUpSellAndNotificationDetails]: ', error);
            }

            this.showPwtAccountDetails = true;
        },

        async callOpenAccount(service) {

            this.loading = true;
            this.loadingMessage = "Issuing account...";
            const initialPayload = this.$parent.getInitialPayload();
            this.currency = initialPayload.transaction.currency ? initialPayload.transaction.currency : (initialPayload.transaction.meta.currency ? initialPayload.transaction.meta.currency : 'NGN');
            const customer = initialPayload.transaction.customer;
            let meta = null;

            if (Object.keys(initialPayload.transaction).includes('meta') && initialPayload.transaction.meta != null) {
                meta = initialPayload.transaction.meta;
                meta.amount = initialPayload.transaction.amount;
            } else {
                meta = {
                    amount: initialPayload.transaction.amount
                };
            }

            let auth_provider = this.current_option.provider;
            if (Object.keys(this.current_option.extras).includes('provider') && !['', null, undefined].includes(this.current_option.extras.provider)) {
                auth_provider = this.current_option.extras.provider;
            }


            try {

                const data2 = {
                    api_key: this.$store.state.api_key,
                    endpoint: 'transact',
                    payload: {
                        request_ref: this.$generateRequestRef(),
                        request_type: service,
                        auth: {
                            type: null,
                            secure: null,
                            auth_provider: auth_provider
                        },
                        transaction: {
                            transaction_ref: this.$store.state.transRef + '-js-oa',
                            transaction_desc: initialPayload.transaction.transaction_desc ? initialPayload.transaction.transaction_desc : "Open Account",
                            transaction_ref_parent: null,
                            amount: 0,
                            customer: customer,
                            meta,
                            details: {
                                name_on_account: `${customer.firstname} ${customer.surname}`,
                                middlename: null,
                                dob: null,
                                gender: null,
                                title: null,
                                address_line_1: null,
                                address_line_2: null,
                                city: null,
                                state: null,
                                country: null
                            }
                        }
                    },
                }
                const dataPayload = this.$generateToken(data2);

                this.$store.dispatch('service_call_payload', data2.payload);

                axios.post(this.baseApiUrl + "v2/onepipe/js", {
                    data: dataPayload
                }, {
                    timeout: this.API_CALL_TIMEOUT, // 3 mins
                    headers: {
                        Authorization: 'bearer ' + this.$store.state.payload.api_key
                    }
                })
                    .then(({
                        data
                    }) => {
                        const hash = data.data;
                        const res = this.$decodeToken(hash);
                        const status = res.status.toLowerCase();
                        let message = res.message;
                        const responseData = res.data;

                        window.raw = JSON.stringify(res);
                        // console.log(res);

                        if (status == "successful") {
                            this.isEnd = true;

                            if (Object.keys(responseData).includes('provider_response') && responseData.provider_response !== null) {
                                let account_details = responseData.provider_response;
                                if (Object.keys(account_details).includes('accountNumber') || Object.keys(account_details).includes('account_number')) {
                                    message = `To complete your payment, kindly transfer ${this.currency}${initialPayload.transaction.amount / 100} to ${account_details.accountNumber || account_details.account_number} in ${account_details.bankName || account_details.bank_name} on behalf of ${account_details.accountName || account_details.account_name}.`
                                    this.handlePWTUpSellAndNotificationDetails(initialPayload, this.current_option.extras, account_details);
                                }
                            }

                            this.loading = false;
                            this.showPwtAccountDetails = true;

                        } else if (["processing", "waitingforotp", "pendingvalidation"].includes(status)) {

                            this.headingMessage = message;
                            this.open_account_otp = this.loadingMessage = '';
                            window.otp_provider = data2.payload.auth.auth_provider;

                            if (Object.keys(responseData).includes('provider_response') && Object.keys(responseData.provider_response).includes('meta')) {
                                if (Object.keys(responseData.provider_response.meta).includes('ussd_code')) {
                                    this.has_ussd = true;
                                    window.ussd_reference = responseData.provider_response.meta.reference;
                                    window.request_type = data2.payload.request_type;
                                    window.otp_transaction_ref = data2.payload.transaction.transaction_ref
                                }
                            }

                            this.loading = false;
                            this.view = "service_call_otp";
                            return true;
                        } else {
                            window.failedFromStart = false;
                            window.failedFromStartMessage = message;
                            this.$router.push('/v2/warning');
                            this.loading = false;
                        }

                    }).catch(error => {
                        console.log(error);
                        window.failedFromStart = false;
                        window.failedFromStartMessage = error;
                        this.$router.push('/v2/warning');
                        this.loading = false;
                    });
            } catch (error) {
                console.log(error);
                window.failedFromStart = false;
                window.failedFromStartMessage = error;
                this.$router.push('/v2/warning');
                this.loading = false;
            }

        },

        submitOtp() {
            this.loading = true;
            this.loadingMessage = 'Validating...'

            let initialPayload = this.$parent.getInitialPayload(),
                payload = {
                    request_ref: this.$generateRequestRef(),
                    request_type: window.request_type,
                    auth: {
                        secure: this.otp,
                        auth_provider: window.otp_provider
                    },
                    transaction: {
                        transaction_ref: window.otp_transaction_ref
                    }
                },
                data2 = {
                    endpoint: 'validate',
                    api_key: this.$store.state.api_key,
                    payload,
                },
                dataPayload = this.$generateToken(data2);

            axios.post(this.baseApiUrl + "v2/onepipe/js", {
                data: dataPayload,
            }, {
                timeout: this.API_CALL_TIMEOUT, // 3 mins
                headers: {
                    Authorization: 'bearer ' + this.$store.state.payload.api_key
                }
            }).then(({
                data
            }) => {
                let hash = data.data,
                    res = this.$decodeToken(hash),
                    status = res.status.toLowerCase(),
                    message = res.message,
                    responseData = res.data;
                window.raw = JSON.stringify(res);

                if (status == "successful") {
                    if (Object.keys(responseData).includes('provider_response') && responseData.provider_response !== null) {
                        let p_res = responseData.provider_response;
                        if (Object.keys(p_res).includes('accountNumber') || Object.keys(p_res).includes('account_number')) {
                            this.handlePWTUpSellAndNotificationDetails(initialPayload, this.current_option.extras, account_details);
                        }
                    }
                    this.showPwtAccountDetails = true;
                    this.loading = false;
                } else {
                    this.loading = false;
                    window.failedFromStart = false;
                    window.failedFromStartMessage = message;
                    this.$router.push('/v2/warning');
                }
            })
                .catch(error => {
                    window.failedFromStartMessage = error;
                    window.failedFromStart = false;
                    this.$router.push('/v2/warning');
                })
        },

        validateUssd() {

            this.loading = true;
            this.loadingMessage = 'Validating...';

            let vm = this,
                initialPayload = this.$parent.getInitialPayload(),
                payload = {
                    request_ref: this.$generateRequestRef(),
                    request_type: window.request_type,
                    auth: {
                        secure: window.ussd_reference,
                    },
                    transaction: {
                        transaction_ref: window.otp_transaction_ref
                    }
                },
                data2 = {
                    api_key: this.$store.state.api_key,
                    endpoint: 'validate',
                    payload
                },
                dataPayload = this.$generateToken(data2);

            axios.post(this.baseApiUrl + "v2/onepipe/js", {
                data: dataPayload,
            }, {
                timeout: this.API_CALL_TIMEOUT, // 3 mins
                headers: {
                    Authorization: 'bearer ' + this.$store.state.payload.api_key
                }
            }).then(({
                data
            }) => {
                let hash = data.data,
                    res = this.$decodeToken(hash),
                    status = res.status.toLowerCase(),
                    message = res.message,
                    responseData = res.data;
                window.raw = JSON.stringify(res);
                if (status == "successful") {
                    if (Object.keys(responseData).includes('provider_response') && responseData.provider_response !== null) {
                        let p_res = responseData.provider_response;
                        if (Object.keys(p_res).includes('accountNumber') || Object.keys(p_res).includes('account_number')) {
                            this.handlePWTUpSellAndNotificationDetails(initialPayload, this.current_option.extras, account_details);
                        }
                    }
                    this.showPwtAccountDetails = true;
                    this.loading = false;
                } else {
                    this.loading = false;
                    window.failedFromStart = false;
                    window.failedFromStartMessage = message;
                    this.$router.push('/v2/warning');
                }
            }).catch(error => {
                window.failedFromStartMessage = error;
                window.failedFromStart = false;
                this.$router.push('/v2/warning');
            })

        },

        async callSendInvoice() {

            this.loading = true;

            // get initial payload
            const initialPayload = this.$parent.getInitialPayload();
            this.currency = initialPayload.transaction.currency ? initialPayload.transaction.currency : (initialPayload.transaction.meta.currency ? initialPayload.transaction.meta.currency : 'NGN');
            const customer = initialPayload.transaction.customer;
            let data2 = {
                endpoint: 'transact',
                api_key: this.$store.state.api_key,
                payload: {
                    "request_ref": this.$generateRequestRef(),
                    "request_type": "send_invoice",
                    "auth": {
                        "type": 'bank.account',
                        "secure": `0987654321;${this.bank_code}`,
                        "auth_provider": this.current_option.provider
                    },
                    "transaction": {
                        "mock_mode": "live",
                        "transaction_ref": this.$store.state.transRef + '-js-si',
                        "transaction_desc": initialPayload.transaction.transaction_desc,
                        "transaction_ref_parent": null,
                        "amount": initialPayload.transaction.amount,
                        "customer": customer,
                    }
                }
            };

            this.$store.dispatch('service_call_payload', data2.payload);

            if (this.$store.state.isFailed)
                data2.payload.parentTransRef = this.$store.state.parentTransRef

            let dataPayload = this.$generateToken(data2);
            axios.post(this.baseApiUrl + "v2/onepipe/js", {
                data: dataPayload,
            }, {
                timeout: this.API_CALL_TIMEOUT, // 3 mins
                headers: {
                    Authorization: 'bearer ' + this.$store.state.payload.api_key
                }
            }).then(({
                data
            }) => {

                let hash = data.data,
                    res = this.$decodeToken(hash),
                    status = res.status.toLowerCase(),
                    message = res.message,
                    responseData = res.data;
                window.raw = JSON.stringify(res);
                // console.log(res);

                if (status == "successful") {
                    this.loading = false;
                    if (Object.keys(responseData).includes('provider_response') && Object.keys(responseData.provider_response).includes('meta')) {
                        if (Object.keys(responseData.provider_response.meta).includes('ussd_code')) {
                            message = `<p class="text-center gray">${responseData.provider_response.meta.additional_message}.</p><div class="col-12 px-0 mt-4 mb-5"><h2 class="emphasized text-center black">${responseData.provider_response.meta.ussd_code}</h2></div>`;
                        }
                    }

                    this.$parent.changeComponent('Status', {
                        type: 'Successful',
                        status_type: 'message',
                        data: responseData,
                        message: message
                    });

                } else {
                    window.failedFromStartMessage = message;
                    window.failedFromStart = false;
                    this.$router.push('/v2/warning');
                }
            })
                .catch(error => {
                    console.log(error);
                    this.loading = false;
                    window.raw = JSON.stringify(error);
                    window.failedFromStart = false;
                    window.failedFromStartMessage = error;
                    this.$router.push('/v2/warning');
                })

        },
        handleContinueToMerchant(data) {
            this.showPwtAccountDetails = true;
            if (window.raw) {
                let res = JSON.parse(window.raw);
                delete res.client_info;
                delete res.paymentoptions;
                this.$emit('continueToMerchant', {
                    message: data.message || res.message,
                    status: data.status,
                    data: res.data,
                })
            }
        },
    }
};
</script>

<style scoped>
.v2-flex-container {
    display: flex !important;
    flex-flow: column wrap;
    transition: all .5s ease-in-out;
    -webkit-transition: all 0.5s ease-in-out;
    -moz-transition: all 0.5s ease-in-out;
    -ms-transition: all 0.5s ease-in-out;
    -o-transition: all 0.5s ease-in-out;
    border: solid 1px #ccc;
    border-radius: 5px;
    border-bottom: none;
    /* filter: drop-shadow(3px 3px 3px rgba(0, 0, 0, 0.6)); */
    webkit-box-shadow: inset 0 0 10px rgba(0, 0, 0, 0.2);
    box-shadow: inset 0 0 10px rgba(0, 0, 0, 0.2);

}

ul.v2-flex-container li {
    list-style-type: none;
    height: 40px;
    cursor: pointer;
    background: #f5f5f578;
    font-size: 12px;
    padding: 8px 0px 8px 0px;
    width: 100%;
    border-bottom: #ded8d8 solid 1px;
    line-height: 40px;
    text-align: left;
}

/* border-radius: 5px 5px 0px 0px; */

ul.v2-flex-container li:first-child {
    border-radius: 5px 5px 0px 0px
}

ul.v2-flex-container li:last-child {
    /* border-bottom: none; */
    border-radius: 0px 0px 5px 5px;
}

ul.v2-flex-container li:hover,
ul.v2-flex-container li:focus {
    background: #e4e4e4;
    color: #000000 !important;
    margin-right: 30px;
}

ul.v2-flex-container li>p:hover,
ul.v2-flex-container li>p:focus {
    color: #000000;
}

ul.v2-flex-container li img {
    height: 30px;
    width: 30px;
    line-height: 30px;
    margin-right: 10px;
    padding-left: 15px;
    vertical-align: middle;
}

.options-list ul li p {
    font-weight: 600;
    vertical-align: middle;
    margin: 0%;
    display: inline-block;
    height: 40px;
    line-height: 40px;
    text-align: left;
}

ul.v2-flex-container li::after {
    content: "\203A";
    font-weight: 300;
    font-size: 25px;
    float: right;
    margin-right: 15px;
}

.provider-logo {
    height: 50px;
    width: auto;
    margin-bottom: 20px;
}

.heading {
    text-align: center;
    width: 100%;
}
</style>
